import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LoftAmendmentsReport } from './Pages';

export const LoftAmendmentsRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={LoftAmendmentsReport} />
    </Fragment>
)